/**
 * Utility functions for working with product variants
 * These functions are exposed globally on the window object
 */

/**
 * Get variant by ID from variants data
 *
 * @param {Array} variantsData - Array of variant data
 * @param {string|number} variantId - Variant ID to find
 * @returns {Object|null} - Found variant or null if not found
 */
window.getVariantById = function(variantsData, variantId) {
    if (!variantsData || !Array.isArray(variantsData)) return null;

    return variantsData.find((variant) => variant.id === variantId) || null;
};

/**
 * Get variant by SKU from variants data
 *
 * @param {Array} variantsData - Array of variant data
 * @param {string} sku - SKU to find
 * @returns {Object|null} - Found variant or null if not found
 */
window.getVariantBySku = function(variantsData, sku) {
    if (!variantsData || !Array.isArray(variantsData)) return null;

    return variantsData.find((variant) => variant.sku === sku) || null;
}; 
